import type { CommandCenterSnapshot } from "../types/login.types";

/**
 * Command Center 표시용 스냅샷.
 * 이후 API 응답으로 교체할 때 이 객체만 매핑하면 됩니다.
 */
export const commandCenterSnapshot: CommandCenterSnapshot = {
  systemStatus: "OPERATIONAL",
  production: {
    totalOutput: 8472,
    totalOutputUnit: "Units",
    totalOutputDelta: 12.4,
    oee: 92.7,
    oeeDelta: 3.1,
    chartValues: [42, 48, 45, 58, 55, 62, 68, 64, 72, 78, 75, 86],
  },
  lines: [
    { id: "line-01", name: "LINE 01", status: "OPERATIONAL" },
    { id: "line-02", name: "LINE 02", status: "OPERATIONAL" },
    { id: "line-03", name: "LINE 03", status: "IDLE" },
    { id: "line-04", name: "LINE 04", status: "MAINTENANCE" },
  ],
  alerts: [
    { id: "critical", label: "CRITICAL", count: 0, severity: "critical" },
    { id: "warning", label: "WARNING", count: 2, severity: "warning" },
    { id: "notice", label: "NOTICE", count: 5, severity: "notice" },
  ],
  networkNodes: [
    { id: "PLAN", label: "PLAN", angle: -90 },
    { id: "EXECUTE", label: "EXECUTE", angle: -30 },
    { id: "QUALITY", label: "QUALITY", angle: 30 },
    { id: "MAINTENANCE", label: "MAINTENANCE", angle: 90 },
    { id: "MATERIAL", label: "MATERIAL", angle: 150 },
    { id: "MONITOR", label: "MONITOR", angle: 210 },
  ],
};

export const REMEMBERED_USER_ID_KEY = "mes_remembered_user_id";
